/*
 * AEVIA — Preferiti (assets/aevia-preferiti.js) — 2026-10-14
 * ---------------------------------------------------------------------
 * Caricato una volta per pagina da sections/header.liquid.
 *
 * Cosa salva: solo gli handle dei prodotti (es. "shampoo-idratante"), in
 * localStorage, con una chiave per proprietario:
 *   aevia_preferiti_v1:guest        chi non ha fatto l'accesso
 *   aevia_preferiti_v1:c<hash>      un cliente (hash md5 dell'id, reso dal
 *                                   Liquid: l'id non compare in chiaro)
 * Così due account sullo stesso dispositivo non vedono i preferiti
 * dell'altro. Al primo accesso i preferiti salvati da ospite passano
 * all'account e la lista ospite viene svuotata.
 * Nessun dato personale, nessun prezzo o titolo salvato: titolo, immagine,
 * prezzo e disponibilità si rileggono sempre da Shopify (Section Rendering
 * API: /products/<handle>?section_id=aevia-preferito). Un prodotto non più
 * pubblicato (404) viene tolto dall'elenco.
 *
 * Limite dichiarato: nessuna sincronizzazione tra dispositivi. Richiederebbe
 * di scrivere dati sul cliente Shopify, cosa che il tema da solo non può
 * fare in modo sicuro (servirebbe un'app o un backend).
 */
(function () {
  'use strict';

  if (window.AeviaPreferiti) return;

  var PREFIX = 'aevia_preferiti_v1:';
  var MAX = 50;
  var CONCURRENCY = 4;
  var SECTION = 'aevia-preferito';
  var HANDLE_RE = /^[^\s\/?#"'<>\\]{1,255}$/;

  var ownerEl = document.querySelector('[data-aevia-fav-owner]');
  var owner = (ownerEl && ownerEl.getAttribute('data-aevia-fav-owner')) || 'guest';
  if (!/^(guest|c[0-9a-f]{1,32})$/.test(owner)) owner = 'guest';
  var KEY = PREFIX + owner;
  var GUEST_KEY = PREFIX + 'guest';

  /* ---------------- archivio ---------------- */

  var memory = {};          // ripiego se localStorage non è disponibile
  var persistent = true;

  function rawGet(key) {
    try { return window.localStorage.getItem(key); }
    catch (e) { persistent = false; return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null; }
  }
  function rawSet(key, value) {
    try { window.localStorage.setItem(key, value); }
    catch (e) { persistent = false; memory[key] = value; }
  }
  function rawRemove(key) {
    try { window.localStorage.removeItem(key); } catch (e) { delete memory[key]; }
  }

  // Lettura difensiva: qualunque valore corrotto diventa un elenco vuoto.
  function parse(raw) {
    var out = [];
    var seen = {};
    var data;
    try { data = JSON.parse(raw || '[]'); } catch (e) { return out; }
    if (!Array.isArray(data)) return out;
    for (var i = 0; i < data.length && out.length < MAX; i++) {
      var it = data[i];
      var h = it && typeof it === 'object' ? it.h : null;
      if (typeof h !== 'string' || !HANDLE_RE.test(h) || seen[h]) continue;
      seen[h] = true;
      out.push({ h: h, t: typeof it.t === 'number' ? it.t : 0 });
    }
    return out;
  }

  function read() { return parse(rawGet(KEY)); }
  function write(list) { rawSet(KEY, JSON.stringify(list.slice(0, MAX))); }

  // Ospite → cliente: una volta, poi la lista ospite si svuota.
  if (owner !== 'guest') {
    var guestList = parse(rawGet(GUEST_KEY));
    if (guestList.length) {
      var mine = read();
      var have = {};
      mine.forEach(function (it) { have[it.h] = true; });
      guestList.forEach(function (it) { if (!have[it.h]) { mine.push(it); have[it.h] = true; } });
      mine.sort(function (a, b) { return b.t - a.t; });
      write(mine);
      rawRemove(GUEST_KEY);
    }
  }

  function has(h) {
    return read().some(function (it) { return it.h === h; });
  }

  function add(h) {
    if (!HANDLE_RE.test(h)) return false;
    var list = read().filter(function (it) { return it.h !== h; });
    list.unshift({ h: h, t: Date.now() });
    write(list);
    return true;
  }

  function remove(h) {
    write(read().filter(function (it) { return it.h !== h; }));
  }

  /* ---------------- annunci ---------------- */

  var announcer = null;
  function announce(msg) {
    if (!announcer) {
      announcer = document.createElement('p');
      announcer.className = 'aevia-visually-hidden';
      announcer.setAttribute('role', 'status');
      announcer.setAttribute('aria-live', 'polite');
      document.body.appendChild(announcer);
    }
    announcer.textContent = '';
    window.setTimeout(function () { announcer.textContent = msg; }, 60);
  }

  /* ---------------- pulsanti e contatore ---------------- */

  function syncButtons(scope) {
    var list = read();
    var saved = {};
    list.forEach(function (it) { saved[it.h] = true; });
    var buttons = (scope || document).querySelectorAll('[data-aevia-fav]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var h = b.getAttribute('data-aevia-fav');
      var title = b.getAttribute('data-aevia-fav-title') || 'prodotto';
      var on = !!saved[h];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? 'Rimuovi dai preferiti: ' : 'Salva nei preferiti: ') + title);
      var label = b.querySelector('[data-aevia-fav-label]');
      if (label) label.textContent = on ? 'Salvato nei preferiti' : 'Salva nei preferiti';
      b.hidden = false;
    }
    var n = list.length;
    var counts = document.querySelectorAll('[data-aevia-fav-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = n > 99 ? '99+' : String(n);
      counts[j].hidden = n === 0;
    }
    var links = document.querySelectorAll('[data-aevia-fav-link]');
    for (var k = 0; k < links.length; k++) {
      if (links[k].classList.contains('aevia-header__icon-btn')) {
        links[k].setAttribute('aria-label', n ? 'Preferiti, ' + n + (n === 1 ? ' prodotto' : ' prodotti') : 'Preferiti');
      }
    }
  }

  function refresh() {
    syncButtons();
    renderLists();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest('[data-aevia-fav]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var h = btn.getAttribute('data-aevia-fav');
      var title = btn.getAttribute('data-aevia-fav-title') || 'Prodotto';
      if (has(h)) {
        remove(h);
        announce(title + ' rimosso dai preferiti.');
      } else if (add(h)) {
        announce(title + ' salvato nei preferiti.');
      }
      refresh();
      return;
    }

    var rm = t.closest('[data-aevia-fav-remove]');
    if (rm) {
      e.preventDefault();
      var rh = rm.getAttribute('data-aevia-fav-remove');
      var item = rm.closest('[data-aevia-fav-item]');
      var next = item && (item.nextElementSibling || item.previousElementSibling);
      remove(rh);
      announce('Prodotto rimosso dai preferiti.');
      pendingFocus = next ? next.getAttribute('data-aevia-fav-item') : '__list__';
      refresh();
    }
  });

  // Un'altra scheda ha modificato i preferiti.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) refresh();
  });

  /* ---------------- elenco Preferiti ---------------- */

  var cache = {};       // handle -> { status: 'ok'|'gone'|'error', html }
  var inflight = {};
  var pendingFocus = null;
  var renderGen = 0;

  function rootUrl() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof r === 'string' && r ? r : '/';
  }

  function load(h) {
    if (cache[h] && cache[h].status !== 'error') return Promise.resolve(cache[h]);
    if (inflight[h]) return inflight[h];
    var url = rootUrl() + 'products/' + encodeURIComponent(h) + '?section_id=' + SECTION;
    var p = window.fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 404) return { status: 'gone' };
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-aevia-fav-card]');
          if (!card) return { status: 'gone' };
          return { status: 'ok', html: card.innerHTML };
        });
      })
      .catch(function () { return { status: 'error' }; })
      .then(function (r) { cache[h] = r; delete inflight[h]; return r; });
    inflight[h] = p;
    return p;
  }

  function loadAll(handles) {
    var results = {};
    var i = 0;
    function worker() {
      if (i >= handles.length) return Promise.resolve();
      var h = handles[i++];
      return load(h).then(function (r) { results[h] = r; return worker(); });
    }
    var workers = [];
    for (var w = 0; w < Math.min(CONCURRENCY, handles.length); w++) workers.push(worker());
    return Promise.all(workers).then(function () { return results; });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildItem(h, r) {
    var li = document.createElement('li');
    li.className = 'aevia-favlist__item';
    li.setAttribute('data-aevia-fav-item', h);
    if (r.status === 'ok') {
      li.innerHTML = r.html;
    } else {
      // Errore di rete: nessun dato inventato, solo il collegamento.
      li.innerHTML = '<p class="aevia-my-aevia__text">Impossibile caricare questo prodotto ora.</p>' +
        '<a class="aevia-btn aevia-btn--text aevia-my-aevia__link" href="' + rootUrl() + 'products/' + encodeURIComponent(h) + '">Apri il prodotto</a>';
    }
    var title = '';
    var titleEl = li.querySelector('.aevia-product-card__title-link');
    if (titleEl) title = titleEl.textContent.trim();
    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'aevia-btn aevia-btn--text aevia-my-aevia__link aevia-favlist__remove';
    rm.setAttribute('data-aevia-fav-remove', h);
    rm.innerHTML = 'Rimuovi' + (title ? '<span class="aevia-visually-hidden"> dai preferiti: ' + escapeHtml(title) + '</span>' : '<span class="aevia-visually-hidden"> dai preferiti</span>');
    li.appendChild(rm);
    return li;
  }

  function renderList(box, list, results) {
    var status = box.querySelector('[data-aevia-fav-status]');
    var grid = box.querySelector('[data-aevia-fav-items]');
    var empty = box.querySelector('[data-aevia-fav-empty]');
    if (!grid || !empty) return;

    grid.innerHTML = '';
    var shown = 0;
    var failed = 0;
    list.forEach(function (it) {
      var r = results[it.h];
      if (!r || r.status === 'gone') return;
      if (r.status === 'error') failed += 1;
      grid.appendChild(buildItem(it.h, r));
      shown += 1;
    });

    grid.hidden = shown === 0;
    empty.hidden = shown !== 0;
    if (status) {
      status.textContent = failed
        ? 'Alcuni prodotti non sono stati caricati. Ricarica la pagina per riprovare.'
        : (persistent ? '' : 'Questo browser non permette di salvare i preferiti: restano solo finché la pagina è aperta.');
    }
    syncButtons(grid);

    if (pendingFocus) {
      var target = null;
      if (pendingFocus !== '__list__') {
        var items = grid.querySelectorAll('[data-aevia-fav-item]');
        for (var i = 0; i < items.length; i++) {
          if (items[i].getAttribute('data-aevia-fav-item') === pendingFocus) { target = items[i].querySelector('[data-aevia-fav-remove]'); break; }
        }
      }
      if (!target) {
        var section = box.closest('[tabindex="-1"]');
        target = shown ? grid.querySelector('[data-aevia-fav-remove]') : (empty.querySelector('a') || section);
      }
      if (target) { try { target.focus(); } catch (e) {} }
    }
  }

  function renderLists() {
    var boxes = document.querySelectorAll('[data-aevia-fav-list]');
    if (!boxes.length) { pendingFocus = null; return; }
    var gen = ++renderGen;
    var list = read();
    if (!list.length) {
      for (var i = 0; i < boxes.length; i++) renderList(boxes[i], [], {});
      pendingFocus = null;
      return;
    }
    if (!window.fetch || !window.DOMParser) return;
    loadAll(list.map(function (it) { return it.h; })).then(function (results) {
      if (gen !== renderGen) return; // superato da un rendering più recente
      // Prodotti non più pubblicati: tolti anche dall'archivio.
      var gone = list.filter(function (it) { return results[it.h] && results[it.h].status === 'gone'; });
      if (gone.length) {
        var goneMap = {};
        gone.forEach(function (it) { goneMap[it.h] = true; });
        write(read().filter(function (it) { return !goneMap[it.h]; }));
        syncButtons();
      }
      for (var j = 0; j < boxes.length; j++) renderList(boxes[j], list, results);
      pendingFocus = null;
    });
  }

  // MY AEVIA aggiorna la propria sezione in pagina.
  document.addEventListener('aevia:mya-updated', function () { syncButtons(); renderLists(); });

  window.AeviaPreferiti = { refresh: refresh, count: function () { return read().length; } };

  function init() {
    syncButtons();
    renderLists();
    // Arrivo da #MyAeviaPreferiti: porta il blocco in vista.
    if (window.location.hash === '#MyAeviaPreferiti') {
      var sec = document.getElementById('MyAeviaPreferiti');
      if (sec) { try { sec.scrollIntoView(); } catch (e) {} }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
